import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';


function AboutSection() {
    return (
        <div className="about-section">
            <h2 className='home-subtitle'>about us</h2>
            <div className='about-wrapper d-flex align-items-center'>
                <p className='about-text'>
                    At BuyOnTrust we understand that life happens. Unforeseen circumstances such as medical bills and job loss, coupled with sky rocketing prices and stagnant wage growth, can quickly result in a downward credit spiral. A damaged credit history can limit our ability to live the life that we've imagined and even keep us from enjoying life’s essentials. Our goal is to be the rising tide that lifts all ships. It is our firm belief that we can offer everyone access to premium products, at an affordable price, no matter their credit history. Feel free to chat live with us or give us a call to learn how we can be a friend to you! Welcome to the BuyOnTrust family.
                </p>
                <LazyLoadImage src='/images/sofa.png' alt="Sofa" />
            </div>
        </div>
    );
}

export default React.memo(AboutSection);